import { baseAPI } from "../baseApi"

export const highwayNetworkApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение общей протяженности опорной сети
        fetchHighwayNetworkTotals: builder.query<any, any>({
            query: () => ({
                url: `objects/HighwayNetworkTotals`
            })
        }),
    })
})

export const {
    useFetchHighwayNetworkTotalsQuery
} = highwayNetworkApiSlice